<template>
    <div class="ModuleName">
        {{ModouleName}}
    </div>
</template>

<script>
export default {
    props:['ModouleName']
}
</script>

<style lang="scss" scoped>
    .ModuleName{
        margin-top: 24px;
        margin-bottom: 8px;
        font-size: 16px;
        color: rgba(102, 102, 102, 1);
    }
</style>